module.exports = __webpack_public_path__ + "static/media/CTLA_3-475w.06312bd4.webp";